export default [
  {
    name: 'mine',
    path: '/mine',
    menuUrl: '/mine',
    image: 'image/home/home-6',
    menuName: '个人空间',
    isParent: true,
    meta: {
      title: '个人空间',
      href: '/mine',
      redirect: 'noredirect',
    },
    component: () => import( /* webpackChunkName: 'mine' */ '@/views/mine'),
  }
]
